<template>
  <v-container id="campuses" fluid tag="section" class="mt-0 pt-0">
    <v-card>
      <v-tabs fixed-tabs show-arrows align-with-title color="primary">
        <v-tab>
          <v-icon left>mdi-office-building</v-icon>
          {{ $i18n.t("Organization Profile") }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-card-account-details</v-icon>
          {{ $i18n.t("Contact Person") }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-circle</v-icon>
          {{ $i18n.t("User Profile") }}
        </v-tab>
        <!-- <v-tab>
              <v-icon left>mdi-home-map-marker</v-icon>
              {{ $i18n.t("Home Location") }}
            </v-tab> -->
        <v-tab>
          <v-icon left>mdi-key</v-icon>
          {{ $i18n.t("Change Password") }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-cellphone-iphone</v-icon>
          {{ $i18n.t("Change Phone") }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-email</v-icon>
          {{ $i18n.t("Change Email") }}
        </v-tab>

        <!-- Organization Profile -->
        <v-tab-item>
          <v-card flat>
            <organization-profile />
          </v-card>
        </v-tab-item>
        <!-- Contact Person -->
        <v-tab-item>
          <v-card flat></v-card>
        </v-tab-item>
        <!-- User Profile -->
        <v-tab-item>
          <v-card flat>
            <user-profile />
          </v-card>
        </v-tab-item>
        <!-- Home Location -->
        <!-- <v-tab-item>
              <v-card flat>
                <home-location />
              </v-card>
            </v-tab-item> -->
        <!-- Change Password -->
        <v-tab-item>
          <v-card flat>
            <change-password />
          </v-card>
        </v-tab-item>
        <!-- Change Phone -->
        <v-tab-item>
          <v-card flat>
            <change-phone />
          </v-card>
        </v-tab-item>
        <!-- Change Email -->
        <v-tab-item>
          <v-card flat>
            <change-email />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "SettingMenu",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: false,
    },
    label: {
      default: "Profile",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
  components: {
    ChangePassword: () => import("@/views/profile/ChangePassword.vue"),
    ChangeEmail: () => import("@/views/profile/ChangeEmail.vue"),
    ChangePhone: () => import("@/views/profile/ChangePhone.vue"),
    HomeLocation: () => import("@/views/profile/HomeLocation.vue"),
    UserProfile: () => import("@/views/profile/UserProfile.vue"),
    OrganizationProfile: () =>
      import("@/views/profile/OrganizationProfile.vue"),
  },
})
export default class MyProfile extends Vue {}
</script>

<style scoped>
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.v-tab {
  justify-content: left;
  margin-left: 0px !important;
}
</style>
